import { _ as _defineProperty, a as _inherits, b as _createClass, c as _objectWithoutProperties, d as _objectSpread2, e as _classCallCheck, f as _callSuper } from '../_helpers/_rollupPluginBabelHelpers.js';
import 'core-js/modules/es.array.map.js';
import { Children, isValidElement, cloneElement, PureComponent } from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { jsx } from 'react/jsx-runtime';

var modules_fc8df42d = {"light":"light_rui_2ac4","alertContainer":"alertContainer_rui_971c","alertInContainer":"alertInContainer_rui_971c alert_rui_25ab"};

var _excluded = ["children", "className"];
var Alerts = /*#__PURE__*/function (_PureComponent) {
  function Alerts() {
    _classCallCheck(this, Alerts);
    return _callSuper(this, Alerts, arguments);
  }
  _inherits(Alerts, _PureComponent);
  return _createClass(Alerts, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        restProps = _objectWithoutProperties(_this$props, _excluded);
      var classes = classNames(modules_fc8df42d.alertContainer, className);
      var show = Children.count(children) > 0;
      if (!show) {
        return null;
      }
      return /*#__PURE__*/createPortal( /*#__PURE__*/jsx("div", _objectSpread2(_objectSpread2({
        "data-test": "alert-container",
        className: classes,
        "aria-live": "polite"
      }, restProps), {}, {
        children: Children.map(children, function (child) {
          if (! /*#__PURE__*/isValidElement(child)) {
            return child;
          }
          var alertClassNames = classNames(modules_fc8df42d.alertInContainer, child.props.className);
          return /*#__PURE__*/cloneElement(child, {
            className: alertClassNames
          });
        })
      })), document.body);
    }
  }]);
}(PureComponent);
_defineProperty(Alerts, "propTypes", {
  children: PropTypes.node,
  className: PropTypes.string
});

export { Alerts as default };
